// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__T68JS","banner":"styles_banner__1Rr8o"};